<div
  class="sidebar__overlay"
  [class.sidebar__overlay--visible]="sidebarSvc.isOpen()"
  (click)="sidebarSvc.close()"
  aria-hidden="true"
></div>

<aside
  class="sidebar flex h-full w-full flex-col items-center overflow-hidden"
  id="sidebar-nav"
  aria-label="Menú principal"
>
  <div class="sidebar__header relative flex w-full shrink-0 items-center justify-center">
    <a class="flex shrink-0 items-center justify-center" routerLink="/" (click)="closeOnMobile()">
      <img
        src="assets/logo.png"
        alt="Logo Centro Deportivo Municipal"
        class="h-22 w-22 object-contain"
      />
    </a>
    <button
      class="sidebar__close-btn"
      type="button"
      (click)="sidebarSvc.close()"
      aria-label="Cerrar menú"
    >
      <svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path d="M6 18L18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>

  <div class="sidebar__nav-container flex min-h-0 w-full flex-1 flex-col items-stretch">

    <nav class="sidebar__nav flex w-full flex-1 flex-col items-stretch" aria-label="Navegación principal">
      <ng-container *ngTemplateOutlet="navTree; context: { $implicit: navItems(), level: 0 }" />

      <ng-template #navTree let-items let-level="level">
        @for (item of items; track item.id) {
          @if (item.children.length) {
            <button
              type="button"
              class="sidebar__link sidebar__link--toggle flex w-full items-center gap-2"
              [class.sidebar__link--active]="isItemActive(item)"
              [class.sidebar__sublink]="level > 0"
              [style.padding-left.rem]="level > 0 ? 1.8 + level : null"
              [attr.aria-expanded]="isMenuOpen(item)"
              (click)="toggleMenu(item)"
            >
              @if (level === 0) { <app-view-icon [route]="item.route" /> }
              @else { <span class="sidebar__chevron" aria-hidden="true">›</span> }
              <span class="sidebar__link-label flex-1 truncate text-left">{{ item.label }}</span>
            </button>
            @if (isMenuOpen(item)) {
              <div class="sidebar__submenu">
                <ng-container *ngTemplateOutlet="navTree; context: { $implicit: item.children, level: level + 1 }" />
              </div>
            }
          } @else if (item.route) {
            <a
              [class]="level === 0 ? 'sidebar__link flex w-full items-center gap-2' : 'sidebar__sublink flex w-full items-center gap-2'"
              [style.padding-left.rem]="level > 0 ? 1.8 + level : null"
              [routerLink]="item.route"
              [class.sidebar__link--active]="level === 0 && isItemActive(item)"
              [class.sidebar__sublink--active]="level > 0 && isItemActive(item)"
              (click)="closeOnMobile()"
            >
              @if (level === 0) { <app-view-icon [route]="item.route" /> }
              @else { <span class="sidebar__chevron" aria-hidden="true">›</span> }
              <span class="sidebar__link-label flex-1 truncate">{{ item.label }}</span>
            </a>
          } @else {
            <span
              [class]="level === 0 ? 'sidebar__link sidebar__link--disabled flex w-full items-center gap-2' : 'sidebar__sublink sidebar__link--disabled flex w-full items-center gap-2'"
              [style.padding-left.rem]="level > 0 ? 1.8 + level : null"
              aria-disabled="true"
            >
              @if (level > 0) { <span class="sidebar__chevron" aria-hidden="true">›</span> }
              <span class="sidebar__link-label flex-1 truncate">{{ item.label }}</span>
            </span>
          }
        }
      </ng-template>
    </nav>

    <button class="sidebar__logout" type="button" aria-label="Cerrar sesión" (click)="logout()">
      Cerrar sesión
    </button>

  </div>
</aside>
